// extracted by mini-css-extract-plugin
export default {"wrapper":"Index_wrapper__wofiC","time":"Index_time__RaXay"};